module.exports = __webpack_public_path__ + "img/play.e1a6c311.png";